// extracted by mini-css-extract-plugin
export var bottomRightDock = "_10-0";